export default {
  // Endpoints
  backendEndPoint: process.env.VUE_APP_BASE_URL,
}
